// extracted by mini-css-extract-plugin
export default {"videoItem":"videoItem_videoItem__bqblL","video":"videoItem_video__QcrEI","thumbnail":"videoItem_thumbnail__JWV+q","title":"videoItem_title__PoaQ9"};